import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import axios from "axios";
import { Container, Row, Col } from "reactstrap";
import Swiper from "react-id-swiper";
import * as vars from "../../constants/constants";
import { messages } from "../../constants/messages";
import { show, hide } from "../../actions/ActivityIndicatorActions";
import { getVideoOrChannelRelatedData } from "../../actions/PlayActions";
import {
  addFavoriteChannel,
  addFavoriteVideo,
  addLikesChannels,
  addLikesVideos,
} from "../../actions/FavoriteActions";
import { showMessage } from "../../actions/FlashMessageActions";
import { resetBack, setHeaderTitle } from "../../actions/HeaderActions";
import { config } from "../../constants/domainConfig";
import { hollywoodMovies } from "../../constants/hollywoodmovies";
import { movies } from "../../constants/movies";
import { esmobiotv } from "../../constants/esmobiotv";
import { safarimovies } from "../../constants/safarimovies";
import { console_log } from "../../utils/helper";
import {
  addChannelHistory,
  addVideoHistory,
  addShowHistory,
} from "../../actions/HistoryActions";
import {
  getChannels,
  getTVCategories,
  getVideos,
  getVideosPackages,
} from "../../actions/CategoryActions";
import { getDetails, getInterests } from "../../actions/AccountActions";
import ReactDOM from "react-dom";
import {
  bannerDetailsVOD,
  bannerDetailsVODMobile,
} from "../../constants/bannerDetailvod";
import {
  bannerDetailsES,
  bannerDetailsESMobile,
} from "../../constants/bannerDetailsES";
import { bidiotvMoviesListByLang } from "./../../utils/helper";
import { sendData } from "../../analytics/sendData";
import { FormattedMessage } from "react-intl";

// const msg = messages[config.lang];

class Category extends Component {
  constructor(props) {
    super(props);
    let bannerText = "Say Hello To The Future of Mobiletainment";
    if (config.subDomain == "be" || config.subDomain == "nl")
      bannerText = "Begroet de toekomst van mobiletainment";
    if (config.subDomain == "it")
      bannerText = `Dai il benvenuto al futuro dell'intrattenimento mobile`;
    if (config.subDomain == "id")
      bannerText = `Sambut Tampilan Baru Mobiletainment`;
    if (config.subDomain == "se")
      bannerText = `Säg hej till mobilunderhållningens framtid`;
    if (config.subDomain == "no")
      bannerText = "Si hei til fremtiden for mobile";
    if (config.subDomain == "sn")
      bannerText = "Dis Bonjour pour l'avenir de Mobiletainment";
    if (config.subDomain == "ee")
      bannerText = "Ütle tere mobiilmeelelahutuse tulevikukle";
    if (config.subDomain == "tr")
      bannerText = "Mobil Eğlencenin Geleceğine Merhaba Deyin";
    if (config.subDomain == "lv")
      bannerText = "Sasveicinieties ar mobilās izklaides nākotni";
    if (config.subDomain == "lt")
      bannerText = "Susipažinkite su mobiliųjų pramogų ateitimi";
    if (config.subDomain == "rs")
      bannerText = "Поздравите будућност мобилне забаве";
    if (config.subDomain == "th")
      bannerText = "กล่าวสวัสดีกับอนาคตของความบันเทิงบนมือถือ";
    if (config.subDomain == "gr")
      bannerText = "Καλώς ήρθατε στο μέλλον της κινητής τηλεφωνίας";
    if (config.lang == "de")
      bannerText = "Begrüßen Sie die Zukunft des Mobiletainment";
    if (config.lang == "fr")
      bannerText = "Dites bonjour à l'avenir du divertissement mobile";
    if (config.lang == "cs") bannerText = "Poznejte budoucnost mobilní zábavy";
    if (config.lang === "es")
      bannerText = "Saluda al futuro del entretenimiento móvil";
    if (config.lang === "pt")
      bannerText = "Diga Olá para o Futuro de Mobiletainment";

    this.state = {
      type: "",
      switchToFavourite: false,
      shuffleCount: 0,
      bannerDetailsTV: [
        {
          text: "Select your favorite <span>channels today!</span>",
          image: "./img/slider/slide-one.jpg",
          shortText: "Mobio TV Channels",
        },
        {
          text: "",
          image: "./img/slider/channel-1.jpeg",
          shortText: "Zoomin TV",
        },
        {
          text: "",
          image: "./img/slider/channel-2.jpeg",
          shortText: "Fitness TV",
        },
        {
          text: "",
          image: "./img/slider/channel-3.jpeg",
          shortText: "Mobio Yoga",
        },
      ],
      bannerDetailsTVMobile: [
        {
          text: "Select your favorite <span>channels today!</span>",
          image: "./img/slider/mobile/mobile-slide-one.jpeg",
          shortText: "Mobio TV Channels",
        },
        {
          text: "",
          image: "./img/slider/mobile/mobile-channel-1.jpeg",
          shortText: "Zoomin TV",
        },
        {
          text: "",
          image: "./img/slider/mobile/mobile-channel-2.jpeg",
          shortText: "Fitness TV",
        },
        {
          text: "",
          image: "./img/slider/mobile/mobile-channel-3.jpeg",
          shortText: "Mobio Yoga",
        },
      ],

      bannerDetailsBidiotv: [
        {
          text: bannerText,
          image: "./img/slider/default-banner.jpg",
          shortText: bannerText,
        },
        {
          text: "",
          image: "./img/slider/bidio-slide-1.jpeg",
          shortText: "Fitness - Start your healthy life today",
        },
        {
          text: "",
          image: "./img/slider/bidio-slide-2.jpeg",
          shortText: "E-Learning - Learn more than 5 languages",
        },
        {
          text: "",
          image: "./img/slider/bidio-slide-3.jpeg",
          shortText: "Yoga - Get your self-realization",
        },
        {
          text: "",
          image: "./img/slider/bidio-slide-4.jpeg",
          shortText: "Fashion & Beauty - Collar up your life",
        },
      ],

      bannerDetailsPremium: [
        {
          text: "",
          image: "https://cdn.mobiotv.com/premium/banner+1.png",
          shortText: "",
        },
        {
          text: "",
          image: "https://cdn.mobiotv.com/premium/banner+2.png",
          shortText: "",
        },
      ],
      bannerDetailsMobilePremium: [
        {
          text: "",
          image: "https://cdn.mobiotv.com/premium/mobile_banner_1.png",
          shortText: "",
        },
        {
          text: "",
          image: "https://cdn.mobiotv.com/premium/mobile_banner_2.png",
          shortText: "",
        },
      ],

      bannerDetailsBidiotvMobile: [
        {
          text: bannerText,
          image: "./img/slider/mobile/mobile-default-banner.jpeg",
          shortText: bannerText,
        },
        {
          text: "",
          image: "./img/slider/mobile/mobile-bidio-slide-1.jpeg",
          shortText: "Fitness - Start your healthy life today",
        },
        {
          text: "",
          image: "./img/slider/mobile/mobile-bidio-slide-2.jpeg",
          shortText: "E-Learning - Learn more than 5 languages",
        },
        {
          text: "",
          image: "./img/slider/mobile/mobile-bidio-slide-3.jpeg",
          shortText: "Yoga - Get your self-realization",
        },
        {
          text: "",
          image: "./img/slider/mobile/mobile-bidio-slide-4.jpeg",
          shortText: "Fashion & Beauty - Collar up your life",
        },
      ],
      bannerDetailstr: [
        { text: "", image: "./img/tr/slide1.png", shortText: "" },
        { text: "", image: "./img/tr/slide2.png", shortText: "" },
        { text: "", image: "./img/tr/slide3.png", shortText: "" },
        { text: "", image: "./img/tr/slide4.png", shortText: "" },
      ],
      bannerDetailsMobiofit: [
        {
          text: "",
          image: "./img/slider/bidio-slide-1.jpeg",
          shortText: "Fitness - Start your healthy life today",
        },
        {
          text: "",
          image: "./img/slider/bidio-slide-3.jpeg",
          shortText: "Yoga - Get your self-realization",
        },
      ],
      bannerDetailsMobiofitMobile: [
        {
          text: "",
          image: "./img/slider/mobile/mobile-bidio-slide-1.jpeg",
          shortText: "Fitness - Start your healthy life today",
        },
        {
          text: "",
          image: "./img/slider/mobile/mobile-bidio-slide-4.jpeg",
          shortText: "Yoga - Get your self-realization",
        },
      ],
      bannerDetailsGH: [
        {
          text: "",
          image: "https://cdn.mobiotv.com/gh/banner+1.png",
          shortText: "Across The Sahara",
        },
        {
          text: "",
          image: "https://cdn.mobiotv.com/gh/banner+2.png",
          shortText: "Bieberza - The Europena Amazon",
        },
      ],
    };
    this.swiper = null;
    this.interval = null;
    this.goToPlay = this.goToPlay.bind(this);
    this.goToPlayMovies = this.goToPlayMovies.bind(this);
    this.goToPlayOthers = this.goToPlayOthers.bind(this);
    this.channelFavorite = this.channelFavorite.bind(this);
    this.isChannelFavorite = this.isChannelFavorite.bind(this);
    this.videoFavorite = this.videoFavorite.bind(this);
    this.isVideoFavorite = this.isVideoFavorite.bind(this);
    this.showFavorite = this.showFavorite.bind(this);
    this.shuffle = this.shuffle.bind(this);
    this.goToDownloadapks = this.goToDownloadapks.bind(this);
  }

  componentWillMount() {
    this.setState({
      type: "vod",
    });
    if (config.title == "bidiotv" || config.title == "es") {
      const authorized = sessionStorage.getItem("authorized")
        ? JSON.parse(sessionStorage.getItem("authorized"))
        : null;
      if (authorized !== null && authorized.token != "") {
        axios.defaults.headers.common["authorization"] = authorized.token;
      }
    }
    window.addEventListener("resize", () => this.setBanner());
    if (config.title === "bidiotv" && config.mainDomain === "mobiotv") {
      document.body.classList.add("show-unsubscribe");
    }
  }

  componentDidMount() {
    sendData(this.props.access.uid, "", "", "viewed", {
      url: window.location.href,
      page: "homepage",
    });
    this.props.setHeaderTitle("");
    this.interval = setInterval(() => {
      if (this.swiper != null) {
        this.swiper.slideNext();
      }
    }, 40000);
    document.body.classList.add("category");
    if (this.props.account.interests.length <= 0) {
      this.props.show();
      setTimeout(() => {
        this.props.hide();
      }, 1500);
      if (config.title == "bidiotv" || config.title == "es") {
        axios
          .all([
            axios.get(vars.BASE_API_URL + "/getUserProfile"),
            axios.get(vars.BASE_API_URL + "/interests"),
            axios.get(vars.BASE_API_URL + "/categories"),
            axios.get(vars.BASE_API_URL + "/favorites"),
            axios.get(vars.BASE_API_URL + "/history"),
            axios.get(vars.BASE_API_URL + "/likes"),
          ])
          .then(
            axios.spread(
              (
                userProfile,
                interests,
                categories,
                favorites,
                history,
                likes,
              ) => {
                // for user details
                if (userProfile.data.data) {
                  this.props.getDetails(userProfile.data.data);
                }

                // for interests
                if (interests.data.data) {
                  this.props.getInterests(interests.data.data);
                }

                // for channel categories
                if (categories.data.data) {
                  this.props.getTVCategories(categories.data.data);
                }

                // for favorites
                if (favorites.data.data) {
                  this.props.addFavoriteChannel(favorites.data.data.channels);
                  this.props.addFavoriteVideo(favorites.data.data.videos);
                }

                // for history
                if (history.data.data) {
                  this.props.addChannelHistory(history.data.data.channels);
                  this.props.addVideoHistory(history.data.data.videos);
                  this.props.addShowHistory(history.data.data.shows);
                }

                // for likes
                if (likes.data.data) {
                  this.props.addLikesChannels(likes.data.data.channels);
                  this.props.addLikesVideos(likes.data.data.videos);
                }
              },
            ),
          );
      }
    } else {
      this.props.getDetails(this.props.account.user);
      this.props.getInterests(this.props.account.interests);
      this.props.getTVCategories(this.props.category.categories);
      this.props.addFavoriteChannel(this.props.favorite.channels);
      this.props.addFavoriteVideo(this.props.favorite.videos);
      this.props.addLikesChannels(this.props.favorite.channelsLiked);
      this.props.addLikesVideos(this.props.favorite.videosLiked);
      this.props.addChannelHistory(this.props.historyVideos.channels);
      this.props.addVideoHistory(this.props.historyVideos.videos);
      this.props.addShowHistory(this.props.historyVideos.shows);
    }
    this.setBanner();

    // let swiper1= ReactDOM.findDOMNode(this.refs['swiperobj']);
    // swiper1.updateSlides();

    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
    document.body.classList.remove("category");
    window.removeEventListener("resize", () => this.setBanner());
    if (document.body.classList.contains("show-unsubscribe")) {
      document.body.classList.remove("show-unsubscribe");
    }
  }

  goToPlay(data, event) {
    event.preventDefault();
    sendData(this.props.access.uid, data.video.name, data.category, "viewed", {
      url: window.location.href,
      page: "video",
    });
    if (
      event.target.tagName == "path" ||
      event.target.classList.contains("favoriteClick")
    ) {
      if (data.channel) {
        this.channelFavorite(data);
      } else {
        this.videoFavorite(data.video);
      }
    } else {
      this.props.getVideoOrChannelRelatedData(data);
      if (data.channel) {
        this.props.history.push(`/play/channel?uid=${this.props.access.uid}`);
      } else {
        this.props.history.push(
          `/play/video?vid=${data.video.id}&uid=${this.props.access.uid}`,
        );
      }
    }
  }
  goToPlayMovies(data, page = "", event) {
    event.preventDefault();
    sendData(this.props.access.uid, data.video.name, data.category, "viewed", {
      url: window.location.href,
      page: "video",
    });
    if (
      event.target.tagName == "path" ||
      event.target.classList.contains("favoriteClick")
    ) {
      if (data.channel) {
        this.channelFavorite(data);
      } else {
        this.videoFavorite(data.video);
      }
    } else {
      this.props.getVideoOrChannelRelatedData(data);
      if (data.channel) {
        this.props.history.push(`/play/channel?uid=${this.props.access.uid}`);
      } else {
        this.props.history.push(
          `/play/video${page !== "" && "/" + page}/?vid=${data.video.id}&uid=${this.props.access.uid}`,
        );
      }
    }
  }
  goToPlayOthers(data, event) {
    event.preventDefault();
    sendData(this.props.access.uid, data.show.name, data.category, "viewed", {
      url: window.location.href,
      page: "video",
    });
    if (data.show) {
      if (
        event.target.tagName == "path" ||
        event.target.classList.contains("favoriteClick")
      ) {
        this.videoFavorite(data.show);
      } else {
        this.props.getVideoOrChannelRelatedData(data);
        this.props.history.push(`/show?uid=${this.props.access.uid}`);
      }
    }
  }

  channelFavorite(data) {
    let favoriteChannels = this.props.favorite.channels;
    let indexOf = favoriteChannels.findIndex((f) => {
      return f.channelId == data.channel.channelId;
    });
    let channelToBeUpdated = {
      channelId: data.channel.channelId,
      channelName: data.channel.channelName,
      channelLang: data.channel.channelLang,
      channelImage: data.channel.channelImage,
      channelLogo: data.channel.channelLogo,
      channelGrade: data.channel.channelGrade,
      channelStatus: data.channel.channelStatus,
      channelBaseline: data.channel.channelBaseline,
      channelCategories: data.channel.channelCategories,
      isFavorite: true,
    };

    if (indexOf == -1) {
      favoriteChannels.push(channelToBeUpdated);
      axios
        .post(vars.BASE_API_URL + "/favorites/channels", channelToBeUpdated)
        .then((response) => {
          this.props.showMessage({
            message: messages[config.lang].addToFavorites,
            type: true,
          });
        })
        .catch((error) => {
          console_log(error);
        });
    } else {
      favoriteChannels.splice(indexOf, 1);
      axios
        .delete(
          vars.BASE_API_URL +
            "/favorites/channels/" +
            channelToBeUpdated.channelId,
        )
        .then((response) => {
          this.props.showMessage({
            message: messages[config.lang].removeFromFavorites,
            type: false,
          });
        })
        .catch((error) => {
          console_log(error);
        });
    }

    this.props.addFavoriteChannel(favoriteChannels);
  }

  videoFavorite(data) {
    let favoriteVideos = this.props.favorite.videos;
    let indexOf = favoriteVideos.findIndex((f) => {
      return f.videoId == data.id;
    });
    let videoToBeUpdated = {
      videoId: data.id,
      duration: data.duration,
      name: data.name,
      preview: data.preview,
    };

    if (indexOf == -1) {
      favoriteVideos.push(videoToBeUpdated);
      axios
        .post(vars.BASE_API_URL + "/favorites/videos", videoToBeUpdated)
        .then((response) => {
          this.props.showMessage({
            message: messages[config.lang].addToFavorites,
            type: true,
          });
          console_log(response);
        })
        .catch((error) => {
          console_log(error);
        });
    } else {
      favoriteVideos.splice(indexOf, 1);
      axios
        .delete(
          vars.BASE_API_URL + "/favorites/videos/" + videoToBeUpdated.videoId,
        )
        .then((response) => {
          this.props.showMessage({
            message: messages[config.lang].removeFromFavorites,
            type: false,
          });
          console_log(response);
        })
        .catch((error) => {
          console_log(error);
        });
    }

    this.props.addFavoriteVideo(favoriteVideos);
  }

  isChannelFavorite(channelId) {
    let indexOf = this.props.favorite.channels.findIndex((f) => {
      return f.channelId == channelId;
    });

    if (indexOf != -1) {
      return true;
    }
    return false;
  }

  isVideoFavorite(videoId) {
    let indexOf = this.props.favorite.videos.findIndex((f) => {
      return f.videoId == videoId;
    });

    if (indexOf != -1) {
      return true;
    }
    return false;
  }

  showFavorite() {
    this.setState({
      switchToFavourite: !this.state.switchToFavourite,
    });
  }

  setBanner() {
    let url1 = window.location.origin;
    let mobileBannerChannels,
      mobileBannerVOD,
      mobileBannerES,
      mobileBannerBidio,
      bannerMobiofit,
      mobileBannerPremium;
    if (window.innerWidth < 576) {
      mobileBannerChannels = this.state.bannerDetailsTVMobile;
      mobileBannerVOD = bannerDetailsVODMobile;
      mobileBannerES = bannerDetailsESMobile;
      mobileBannerBidio = this.state.bannerDetailsBidiotvMobile;
      mobileBannerPremium = this.state.bannerDetailsMobilePremium;
      bannerMobiofit = this.state.bannerDetailsMobiofitMobile;
    } else {
      mobileBannerChannels = this.state.bannerDetailsTV;
      mobileBannerVOD = bannerDetailsVOD;
      mobileBannerES = bannerDetailsES;
      mobileBannerBidio = this.state.bannerDetailsBidiotv;
      mobileBannerPremium = this.state.bannerDetailsPremium;
      bannerMobiofit = this.state.bannerDetailsMobiofit;
    }
    if (config.lang == "ar")
      mobileBannerBidio[0].text = `قل مرحباَ لمستقبل الترفيه`;
    if (config.lang == "en")
      mobileBannerBidio[0].text = "Say Hello To The Future of Mobiletainment";

    if (config.subDomain == "id" || config.subDomain == "sa") {
      mobileBannerBidio = mobileBannerBidio.filter((banner) => {
        return banner.shortText != "Fitness - Start your healthy life today";
      });
    }
    const params = {
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      },
      lazy: {
        loadPrevNext: true,
      },
      loop: true,
    };
    if (this.state.type == "tv") {
      return (
        <div className="banner-slider__wrap">
          <Swiper
            {...params}
            ref={(node) => (node ? (this.swiper = node.swiper) : null)}
            rebuildOnUpdate={true}
          >
            {mobileBannerChannels.map((banner, key) => {
              return (
                <div className="swiper-image-wrapper">
                  <div className="swiper-image-container">
                    <div
                      key={key}
                      className={
                        key == 0
                          ? "gradient-overlay gradient-overlay--orange"
                          : ""
                      }
                    >
                      {banner.text ? (
                        <div
                          className="banner-slider__content"
                          dangerouslySetInnerHTML={{ __html: banner.text }}
                        ></div>
                      ) : (
                        ""
                      )}
                      <img
                        className="banner-slider__image"
                        src={banner.image}
                        alt={banner.shortText}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </Swiper>
        </div>
      );
    } else if (config.subDomain == "tr") {
      return (
        <div className="banner-slider__wrap">
          <Swiper
            {...params}
            ref={(node) => (node ? (this.swiper = node.swiper) : null)}
            rebuildOnUpdate={true}
          >
            {this.state.bannerDetailstr.map((banner, key) => {
              return (
                <div className="swiper-image-wrapper">
                  <div className="swiper-image-container">
                    <div key={key} className={key == 0 ? "overlay-bg" : ""}>
                      {banner.text ? (
                        <div className="banner__content">
                          <div className="banner__content__text">
                            <h1
                              className="banner__content__heading"
                              dangerouslySetInnerHTML={{ __html: banner.text }}
                            ></h1>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                      <img
                        className="banner-slider__image"
                        src={banner.image}
                        alt={banner.shortText}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </Swiper>
        </div>
      );
    } else if (config.subDomain.includes("mobiofit")) {
      return (
        <div className="banner-slider__wrap">
          <Swiper
            {...params}
            ref={(node) => (node ? (this.swiper = node.swiper) : null)}
            rebuildOnUpdate={true}
          >
            {bannerMobiofit.map((banner, key) => {
              return (
                <div className="swiper-image-wrapper">
                  <div className="swiper-image-container">
                    <div key={key} className={key == 0 ? "overlay-bg" : ""}>
                      {banner.text ? (
                        <div className="banner__content">
                          <div className="banner__content__text">
                            <h1
                              className="banner__content__heading"
                              dangerouslySetInnerHTML={{ __html: banner.text }}
                            ></h1>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                      <img
                        className="banner-slider__image"
                        src={banner.image}
                        alt={banner.shortText}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </Swiper>
        </div>
      );
    } else if (config.subDomain === "premium") {
      return (
        <div className="banner-slider__wrap">
          <Swiper
            {...params}
            ref={(node) => (node ? (this.swiper = node.swiper) : null)}
            rebuildOnUpdate={true}
          >
            {mobileBannerPremium.map((banner, key) => {
              return (
                <div className="swiper-image-wrapper">
                  <div className="swiper-image-container">
                    <div key={key} className={key == 0 ? "overlay-bg" : ""}>
                      {banner.text ? (
                        <div className="banner__content">
                          <div className="banner__content__text">
                            <h1
                              className="banner__content__heading"
                              dangerouslySetInnerHTML={{ __html: banner.text }}
                            ></h1>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                      <img
                        className="banner-slider__image"
                        src={banner.image}
                        alt={banner.shortText}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </Swiper>
        </div>
      );
    } else if (config.subDomain == "gh") {
      return (
        <div className="banner-slider__wrap">
          <Swiper
            {...params}
            ref={(node) => (node ? (this.swiper = node.swiper) : null)}
            rebuildOnUpdate={true}
          >
            {this.state.bannerDetailsGH.map((banner, key) => {
              return (
                <div className="swiper-image-wrapper">
                  <div className="swiper-image-container">
                    <div key={key} className={key == 0 ? "overlay-bg" : ""}>
                      {banner.text ? (
                        <div className="banner__content">
                          <div className="banner__content__text">
                            <h1
                              className="banner__content__heading"
                              dangerouslySetInnerHTML={{ __html: banner.text }}
                            ></h1>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                      <img
                        className="banner-slider__image"
                        src={banner.image}
                        alt={banner.shortText}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </Swiper>
        </div>
      );
    } else if (config.title == "bidiotv") {
      return (
        <div className="banner-slider__wrap">
          <Swiper
            {...params}
            ref={(node) => (node ? (this.swiper = node.swiper) : null)}
            rebuildOnUpdate={true}
          >
            {mobileBannerBidio.map((banner, key) => {
              return (
                <div className="swiper-image-wrapper">
                  <div className="swiper-image-container">
                    <div key={key} className={key == 0 ? "overlay-bg" : ""}>
                      {banner.text ? (
                        <div className="banner__content">
                          <div className="banner__content__text">
                            <h1
                              className="banner__content__heading"
                              dangerouslySetInnerHTML={{ __html: banner.text }}
                            ></h1>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                      <img
                        className="banner-slider__image"
                        src={banner.image}
                        alt={banner.shortText}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </Swiper>
        </div>
      );
    } else if (config.title == "es") {
      return (
        <div className="banner-slider__wrap">
          <Swiper
            {...params}
            ref={(node) => (node ? (this.swiper = node.swiper) : null)}
            rebuildOnUpdate={true}
          >
            {mobileBannerES.map((banner, key) => {
              return (
                <div className="swiper-image-wrapper">
                  <div className="swiper-image-container">
                    <div
                      key={key}
                      className={key == 0 ? "overlay-bg" : ""}
                      onClick={this.goToPlayOthers.bind(this, {
                        show: banner.video,
                      })}
                    >
                      {banner.text ? (
                        <div className="banner__content">
                          <div className="banner__content__text">
                            <h1
                              className="banner__content__heading"
                              dangerouslySetInnerHTML={{ __html: banner.text }}
                            ></h1>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                      <img
                        className="banner-slider__image"
                        src={banner.image}
                        alt={banner.shortText}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </Swiper>
        </div>
      );
    } else {
      return (
        <div className="banner-slider__wrap">
          <Swiper
            {...params}
            ref={(node) => (node ? (this.swiper = node.swiper) : null)}
            rebuildOnUpdate={true}
          >
            {mobileBannerVOD.map((banner, key) => {
              return (
                <div className="swiper-image-wrapper">
                  <div className="swiper-image-container">
                    <div
                      key={key}
                      className={
                        key == 0
                          ? "gradient-overlay gradient-overlay--pink"
                          : ""
                      }
                      onClick={this.goToPlayOthers.bind(this, {
                        show: banner.video,
                      })}
                    >
                      {banner.text ? (
                        <div
                          className="banner-slider__content"
                          dangerouslySetInnerHTML={{ __html: banner.text }}
                        ></div>
                      ) : (
                        ""
                      )}
                      <img
                        className="banner-slider__image"
                        src={banner.image}
                        alt={banner.shortText}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </Swiper>
        </div>
      );
    }
  }
  gotovod() {
    this.setState({
      switchToFavourite: !this.state.switchToFavourite,
    });
  }

  setVideos() {
    let favoriteVideosIds = this.props.favorite.videos.map((v) => v.videoId);
    let packagvideosbidio = [].concat.apply(
      [],
      bidiotvMoviesListByLang.map((c) => c.videos),
    );
    let packagvideosbidioFavorite = packagvideosbidio.filter((m) => {
      if (~favoriteVideosIds.indexOf(m.id)) return m;
    });
    let mixContent = bidiotvMoviesListByLang.concat(this.props.category.videos);
    let mixcontentVideos = [].concat.apply(
      [],
      mixContent.map((c) => c.videos),
    );
    let mixcontentVideosFavorite = mixcontentVideos.filter((m) => {
      if (~favoriteVideosIds.indexOf(m.id)) return m;
    });
    let orange = [].concat.apply(
      [],
      this.props.category.videos.map((c) => c.videos),
    );
    let orangeFavorite = orange.filter((m) => {
      if (~favoriteVideosIds.indexOf(m.id)) return m;
    });
    let recentlyAdded = [].concat.apply(
      [],
      movies.map((c) => c.videos),
    );
    let recentlyAddedFavorite = recentlyAdded.filter((m) => {
      if (~favoriteVideosIds.indexOf(m.id)) return m;
    });

    let configuration = config;
    const slides = {
        spaceBetween: 30,
        direction: "horizontal",
        slidesPerView: "auto",
        speed: 500,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          575: {
            spaceBetween: 15,
          },
        },
      },
      gridIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 290 290" width="12" height="12"><g fill="${config.useMobiofitTheme ? "#347CFD" : "#d51a92"}"><path d="M0 220h70v70H0zM0 110h70v70H0zM0 0h70v70H0zM110 220h70v70h-70zM110 110h70v70h-70zM110 0h70v70h-70zM220 220h70v70h-70zM220 110h70v70h-70zM220 0h70v70h-70z"/></g></svg>`;

    if (this.state.type == "vod") {
      if (configuration.title == "bidiotv") {
        if (!this.state.switchToFavourite) {
          return bidiotvMoviesListByLang
            .sort((a, b) => a.id > b.id)
            .map((videos, key) => {
              let vid_category = videos.name[config.lang];

              return (
                <div
                  key={key}
                  className="category-slider"
                  style={config.lang ? { marginRight: "30px" } : {}}
                >
                  <Row>
                    <Col>
                      <div className="d-flex justify-content-between channel-head">
                        <h3
                          className={
                            config.useMobiofitTheme
                              ? " channel-title channel-title-mobiofit"
                              : "channel-title"
                          }
                        >
                          {videos.name[config.lang] || videos.name.en}
                        </h3>
                        <a
                          className={
                            config.useMobiofitTheme
                              ? "channel-browse channel-browse-mobiofit"
                              : "channel-browse"
                          }
                          href={"/#/videos/" + videos.id}
                        >
                          <span
                            className={
                              config.useMobiofitTheme
                                ? "grid-icon-mobiofit"
                                : "grid-icon"
                            }
                            dangerouslySetInnerHTML={{ __html: gridIcon }}
                          />
                          <FormattedMessage
                            id="viewAll"
                            defaultMessage="View All"
                          />
                        </a>
                      </div>
                      {videos.videos ? (
                        <Swiper
                          {...slides}
                          rebuildOnUpdate={false}
                          shouldSwiperUpdate={true}
                        >
                          {this.shuffle(videos.videos).map((v, k) => {
                            return (
                              <div
                                key={v.id}
                                className="channels-thumb"
                                onClick={this.goToPlay.bind(this, {
                                  video: v,
                                  category: vid_category,
                                  categoryId: videos.id,
                                })}
                              >
                                <div className="channels-image">
                                  <img
                                    className="channels-thumb__image"
                                    src={v.preview}
                                    alt={v.name}
                                  />
                                  <div className="channels-thumb__details">
                                    <div className="channels-thumb__fav">
                                      <input
                                        className="icon-toggle favoriteClick"
                                        id={"vod-" + v.id}
                                        type="checkbox"
                                        checked={this.isVideoFavorite(v.id)}
                                        onChange={() => {
                                          console_log("favorite Changed");
                                        }}
                                      />
                                      <label
                                        className="icon-toggle-label favoriteClick"
                                        htmlFor={"vod-" + v.id}
                                      >
                                        <span className="favoriteClick">
                                          <i
                                            className="fa fa-star favoriteClick"
                                            aria-hidden="true"
                                          ></i>
                                        </span>
                                      </label>
                                    </div>
                                    <div className="channels-thumb__inner">
                                      <div className="channels-thumb__name">
                                        <FormattedMessage
                                          id={v.name}
                                          defaultMessage={v.name}
                                        />
                                      </div>
                                      {/* <div className="channels-thumb__extra">
                                                                                <span className="channels-thumb__time">1h 40m</span>
                                                                            </div> */}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </Swiper>
                      ) : (
                        ""
                      )}
                    </Col>
                  </Row>
                </div>
              );
            });
        } else if (
          this.state.switchToFavourite &&
          packagvideosbidioFavorite.length <= 0
        ) {
          return (
            <div className="no-favorite-category">
              <div className="no-favorites__pane">
                <h4 className="favorites__pane__title">
                  <FormattedMessage
                    id="noVids"
                    defaultMessage="No Videos Added To Favorites Yet"
                  />
                </h4>
                <p className="favorites__pane__text">
                  <FormattedMessage
                    id="addYour"
                    defaultMessage="Add your favorite videos to access and watch easily without any hassles."
                  />
                </p>
              </div>
              <div className="text-center">
                <a
                  className="common-btn common-btn--pink common-btn--fav"
                  onClick={() => this.gotovod()}
                >
                  <span className="common-btn__text">
                    <FormattedMessage
                      id="exploreVids"
                      defaultMessage="Explore Videos"
                    />
                  </span>
                </a>
              </div>
            </div>
          );
        } else {
          return bidiotvMoviesListByLang
            .sort((a, b) => a.id > b.id)
            .map((videos, key) => {
              let packageVideosbidio = videos.videos.filter((video) => {
                if (~favoriteVideosIds.indexOf(video.id)) {
                  return video;
                }
              });
              if (packageVideosbidio.length > 0) {
                return (
                  <div key={key} className="category-slider">
                    <Row>
                      <Col>
                        <div className="d-flex justify-content-between channel-head">
                          <h3
                            className={
                              config.useMobiofitTheme
                                ? " channel-title channel-title-mobiofit"
                                : "channel-title"
                            }
                          >
                            {videos.name[config.lang] || videos.name.en}
                          </h3>
                          <a
                            className={
                              config.useMobiofitTheme
                                ? "channel-browse channel-browse-mobiofit"
                                : "channel-browse"
                            }
                            href={"/#/videos/" + videos.id}
                          >
                            <span
                              className={
                                config.useMobiofitTheme
                                  ? "grid-icon-mobiofit"
                                  : "grid-icon"
                              }
                              dangerouslySetInnerHTML={{ __html: gridIcon }}
                            />
                            <FormattedMessage
                              id="viewAll"
                              defaultMessage="View All"
                            />
                          </a>
                        </div>
                        {packageVideosbidio ? (
                          <Swiper
                            {...slides}
                            rebuildOnUpdate={false}
                            shouldSwiperUpdate={true}
                          >
                            {this.shuffle(packageVideosbidio).map((v, k) => {
                              return (
                                <div
                                  key={v.id}
                                  className="channels-thumb"
                                  onClick={this.goToPlay.bind(this, {
                                    video: v,
                                    categoryId: videos.id,
                                  })}
                                >
                                  <div className="channels-image">
                                    <img
                                      className="channels-thumb__image"
                                      src={v.preview}
                                      alt={v.name}
                                    />
                                    <div className="channels-thumb__details">
                                      <div className="channels-thumb__fav">
                                        <input
                                          className="icon-toggle favoriteClick"
                                          id={"vod-" + v.id}
                                          type="checkbox"
                                          checked={this.isVideoFavorite(v.id)}
                                          onChange={() => {
                                            console_log("favorite Changed");
                                          }}
                                        />
                                        <label
                                          className="icon-toggle-label favoriteClick"
                                          htmlFor={"vod-" + v.id}
                                        >
                                          <span className="favoriteClick">
                                            <i
                                              className="fa fa-star favoriteClick"
                                              aria-hidden="true"
                                            ></i>
                                          </span>
                                        </label>
                                      </div>
                                      <div className="channels-thumb__inner">
                                        <div className="channels-thumb__name">
                                          {v.name}
                                        </div>
                                        {/* <div className="channels-thumb__extra">
                                                                                    <span className="channels-thumb__time">1h 40m</span>
                                                                                </div> */}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </Swiper>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>
                  </div>
                );
              }
            });
        }
      } else if (configuration.title == "watch") {
        if (!this.state.switchToFavourite) {
          return mixContent
            .sort((a, b) => a.id > b.id)
            .map((videos, key) => {
              return (
                <div key={key} className="category-slider">
                  <Row>
                    <Col>
                      <div className="d-flex justify-content-between channel-head">
                        <h3 className="channel-title">
                          {videos.name[config.lang]}
                        </h3>
                        <a
                          className="channel-browse"
                          href={"/#/videos/" + videos.id}
                        >
                          <span
                            className={
                              config.useMobiofitTheme
                                ? "grid-icon-mobiofit"
                                : "grid-icon"
                            }
                            dangerouslySetInnerHTML={{ __html: gridIcon }}
                          />
                          <FormattedMessage
                            id="viewAll"
                            defaultMessage="View All"
                          />
                        </a>
                      </div>
                      {videos.videos ? (
                        <Swiper
                          {...slides}
                          rebuildOnUpdate={false}
                          shouldSwiperUpdate={true}
                        >
                          {this.shuffle(videos.videos).map((v, k) => {
                            return (
                              <div
                                key={v.id}
                                className="channels-thumb"
                                onClick={this.goToPlay.bind(this, {
                                  video: v,
                                  categoryId: videos.id,
                                })}
                              >
                                <div className="channels-image">
                                  <img
                                    className="channels-thumb__image"
                                    src={v.preview}
                                    alt={v.name}
                                  />
                                  <div className="channels-thumb__details">
                                    <div className="channels-thumb__fav">
                                      <input
                                        className="icon-toggle favoriteClick"
                                        id={"vod-" + v.id}
                                        type="checkbox"
                                        checked={this.isVideoFavorite(v.id)}
                                        onChange={() => {
                                          console_log("favorite Changed");
                                        }}
                                      />
                                      <label
                                        className="icon-toggle-label favoriteClick"
                                        htmlFor={"vod-" + v.id}
                                      >
                                        <span className="favoriteClick">
                                          <i
                                            className="fa fa-star favoriteClick"
                                            aria-hidden="true"
                                          ></i>
                                        </span>
                                      </label>
                                    </div>
                                    <div className="channels-thumb__inner">
                                      <div className="channels-thumb__name">
                                        {v.name}
                                      </div>
                                      {/* <div className="channels-thumb__extra">
                                                                                <span className="channels-thumb__time">1h 40m</span>
                                                                            </div> */}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </Swiper>
                      ) : (
                        ""
                      )}
                    </Col>
                  </Row>
                </div>
              );
            });
        } else if (
          this.state.switchToFavourite &&
          mixcontentVideosFavorite.length <= 0
        ) {
          return (
            <div className="no-favorite-category">
              <div className="no-favorites__pane">
                <h4 className="favorites__pane__title">
                  <FormattedMessage
                    id="noVids"
                    defaultMessage="No Videos Added To Favorites Yet"
                  />
                </h4>
                <p className="favorites__pane__text">
                  <FormattedMessage
                    id="addYour"
                    defaultMessage="Add your favorite videos to access and watch easily without any hassles."
                  />
                </p>
              </div>
              <div className="text-center">
                <a
                  className="common-btn common-btn--pink common-btn--fav"
                  onClick={() => this.gotovod()}
                >
                  <span className="common-btn__text">
                    <FormattedMessage
                      id="exploreVids"
                      defaultMessage="Explore Videos"
                    />
                  </span>
                </a>
              </div>
            </div>
          );
        } else {
          return mixContent
            .sort((a, b) => a.id > b.id)
            .map((videos, key) => {
              let packageVideos = videos.videos.filter((video) => {
                if (~favoriteVideosIds.indexOf(video.id)) {
                  return video;
                }
              });
              if (packageVideos.length > 0) {
                return (
                  <div key={key} className="category-slider">
                    <Row>
                      <Col>
                        <div className="d-flex justify-content-between channel-head">
                          <h3 className="channel-title">
                            {videos.name[config.lang]}
                          </h3>
                          <a
                            className="channel-browse"
                            href={"/#/videos/" + videos.id}
                          >
                            <span
                              className={
                                config.useMobiofitTheme
                                  ? "grid-icon-mobiofit"
                                  : "grid-icon"
                              }
                              dangerouslySetInnerHTML={{ __html: gridIcon }}
                            />
                            <FormattedMessage
                              id="viewAll"
                              defaultMessage="View All"
                            />
                          </a>
                        </div>
                        {packageVideos ? (
                          <Swiper
                            {...slides}
                            rebuildOnUpdate={false}
                            shouldSwiperUpdate={true}
                          >
                            {this.shuffle(packageVideos).map((v, k) => {
                              return (
                                <div
                                  key={v.id}
                                  className="channels-thumb"
                                  onClick={this.goToPlay.bind(this, {
                                    video: v,
                                    categoryId: videos.id,
                                  })}
                                >
                                  <div className="channels-image">
                                    <img
                                      className="channels-thumb__image"
                                      src={v.preview}
                                      alt={v.name}
                                    />
                                    <div className="channels-thumb__details">
                                      <div className="channels-thumb__fav">
                                        <input
                                          className="icon-toggle favoriteClick"
                                          id={"vod-" + v.id}
                                          type="checkbox"
                                          checked={this.isVideoFavorite(v.id)}
                                          onChange={() => {
                                            console_log("favorite Changed");
                                          }}
                                        />
                                        <label
                                          className="icon-toggle-label favoriteClick"
                                          htmlFor={"vod-" + v.id}
                                        >
                                          <span className="favoriteClick">
                                            <i
                                              className="fa fa-star favoriteClick"
                                              aria-hidden="true"
                                            ></i>
                                          </span>
                                        </label>
                                      </div>
                                      <div className="channels-thumb__inner">
                                        <div className="channels-thumb__name">
                                          {v.name}
                                        </div>
                                        {/* <div className="channels-thumb__extra">
                                                                                    <span className="channels-thumb__time">1h 40m</span>
                                                                                </div> */}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </Swiper>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>
                  </div>
                );
              }
            });
        }
      } else if (configuration.title == "es") {
        return <div></div>;
      } else if (!this.state.switchToFavourite && this.props.category.videos) {
        return this.props.category.videos
          .sort((a, b) => a.id > b.id)
          .map((videos, key) => {
            return (
              <div key={key} className="category-slider">
                <Row>
                  <Col>
                    <div className="d-flex justify-content-between channel-head">
                      <h3 className="channel-title">{videos.name}</h3>
                      <a
                        className="channel-browse"
                        href={"/#/videos/" + videos.id}
                      >
                        <span
                          className={
                            config.useMobiofitTheme
                              ? "grid-icon-mobiofit"
                              : "grid-icon"
                          }
                          dangerouslySetInnerHTML={{ __html: gridIcon }}
                        />
                        <FormattedMessage
                          id="viewAll"
                          defaultMessage="View All"
                        />
                      </a>
                    </div>
                    {videos.videos ? (
                      <Swiper
                        {...slides}
                        rebuildOnUpdate={false}
                        shouldSwiperUpdate={true}
                      >
                        {this.shuffle(videos.videos).map((v, k) => {
                          return (
                            <div
                              key={v.id}
                              className="channels-thumb"
                              onClick={this.goToPlay.bind(this, {
                                video: v,
                                categoryId: videos.id,
                              })}
                            >
                              <div className="channels-image">
                                <img
                                  className="channels-thumb__image"
                                  src={v.preview}
                                  alt={v.name}
                                />
                                <div className="channels-thumb__details">
                                  <div className="channels-thumb__fav">
                                    <input
                                      className="icon-toggle favoriteClick"
                                      id={"vod-" + v.id}
                                      type="checkbox"
                                      checked={this.isVideoFavorite(v.id)}
                                      onChange={() => {
                                        console_log("favorite Changed");
                                      }}
                                    />
                                    <label
                                      className="icon-toggle-label favoriteClick"
                                      htmlFor={"vod-" + v.id}
                                    >
                                      <span className="favoriteClick">
                                        <i
                                          className="fa fa-star favoriteClick"
                                          aria-hidden="true"
                                        ></i>
                                      </span>
                                    </label>
                                  </div>
                                  <div className="channels-thumb__inner">
                                    <div className="channels-thumb__name">
                                      {v.name}
                                    </div>
                                    {/* <div className="channels-thumb__extra">
                                                                            <span className="channels-thumb__time">1h 40m</span>
                                                                        </div> */}
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </Swiper>
                    ) : (
                      ""
                    )}
                  </Col>
                </Row>
              </div>
            );
          });
      } else {
        if (orangeFavorite.length <= 0 && recentlyAddedFavorite.length <= 0) {
          return (
            <div className="no-favorite-category">
              <div className="no-favorites__pane">
                <h4 className="favorites__pane__title">
                  <FormattedMessage
                    id="noVids"
                    defaultMessage="No Videos Added To Favorites Yet"
                  />
                </h4>
                <p className="favorites__pane__text">
                  <FormattedMessage
                    id="addYour"
                    defaultMessage="Add your favorite videos to access and watch easily without any hassles."
                  />
                </p>
              </div>
              <div className="text-center">
                <a
                  className="common-btn common-btn--pink common-btn--fav"
                  onClick={() => this.gotovod()}
                >
                  <span className="common-btn__text">
                    <FormattedMessage
                      id="exploreVids"
                      defaultMessage="Explore Videos"
                    />
                  </span>
                </a>
              </div>
            </div>
          );
        } else {
          return this.props.category.videos
            .sort((a, b) => a.id > b.id)
            .map((videos, key) => {
              let packageVideos = videos.videos.filter((video) => {
                if (~favoriteVideosIds.indexOf(video.id)) {
                  return video;
                }
              });
              if (packageVideos.length > 0) {
                return (
                  <div key={key} className="category-slider">
                    <Row>
                      <Col>
                        <div className="d-flex justify-content-between channel-head">
                          <h3 className="channel-title">{videos.name}</h3>
                          <a
                            className="channel-browse"
                            href={"/#/videos/" + videos.id}
                          >
                            <span
                              className={
                                config.useMobiofitTheme
                                  ? "grid-icon-mobiofit"
                                  : "grid-icon"
                              }
                              dangerouslySetInnerHTML={{ __html: gridIcon }}
                            />
                            <FormattedMessage
                              id="viewAll"
                              defaultMessage="View All"
                            />
                          </a>
                        </div>
                        {packageVideos ? (
                          <Swiper
                            {...slides}
                            rebuildOnUpdate={false}
                            shouldSwiperUpdate={true}
                          >
                            {this.shuffle(packageVideos).map((v, k) => {
                              return (
                                <div
                                  key={v.id}
                                  className="channels-thumb"
                                  onClick={this.goToPlay.bind(this, {
                                    video: v,
                                    categoryId: videos.id,
                                  })}
                                >
                                  <div className="channels-image">
                                    <img
                                      className="channels-thumb__image"
                                      src={v.preview}
                                      alt={v.name}
                                    />
                                    <div className="channels-thumb__details">
                                      <div className="channels-thumb__fav">
                                        <input
                                          className="icon-toggle favoriteClick"
                                          id={"vod-" + v.id}
                                          type="checkbox"
                                          checked={this.isVideoFavorite(v.id)}
                                          onChange={() => {
                                            console_log("favorite Changed");
                                          }}
                                        />
                                        <label
                                          className="icon-toggle-label favoriteClick"
                                          htmlFor={"vod-" + v.id}
                                        >
                                          <span className="favoriteClick">
                                            <i
                                              className="fa fa-star favoriteClick"
                                              aria-hidden="true"
                                            ></i>
                                          </span>
                                        </label>
                                      </div>
                                      <div className="channels-thumb__inner">
                                        <div className="channels-thumb__name">
                                          {v.name}
                                        </div>
                                        {/* <div className="channels-thumb__extra">
                                                                                    <span
                                                                                        className="channels-thumb__time">1h 40m</span>
                                                                                </div> */}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </Swiper>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>
                  </div>
                );
              }
            });
        }
      }
    }
  }
  setMovies() {
    let favoriteVideosIds = this.props.favorite.videos.map((v) => v.videoId);
    let packagvideosbidio = [].concat.apply(
      [],
      hollywoodMovies.map((c) => c.videos),
    );
    let packagvideosbidioFavorite = packagvideosbidio.filter((m) => {
      if (~favoriteVideosIds.indexOf(m.id)) return m;
    });
    // let mixContent = bidiotvMovies.concat(this.props.category.videos)
    // let mixcontentVideos = [].concat.apply([], mixContent.map((c) => c.videos));
    // let mixcontentVideosFavorite = mixcontentVideos.filter((m) => {if (~favoriteVideosIds.indexOf(m.id)) return m});
    let orange = [].concat.apply(
      [],
      this.props.category.videos.map((c) => c.videos),
    );
    let orangeFavorite = orange.filter((m) => {
      if (~favoriteVideosIds.indexOf(m.id)) return m;
    });
    let recentlyAdded = [].concat.apply(
      [],
      movies.map((c) => c.videos),
    );
    let recentlyAddedFavorite = recentlyAdded.filter((m) => {
      if (~favoriteVideosIds.indexOf(m.id)) return m;
    });

    let configuration = config;
    const slides = {
        spaceBetween: 10,
        direction: "horizontal",
        slidesPerView: "auto",
        speed: 500,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          575: {
            spaceBetween: 15,
          },
        },
      },
      gridIcon =
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 290 290" width="12" height="12"><g fill="#d51a92"><path d="M0 220h70v70H0zM0 110h70v70H0zM0 0h70v70H0zM110 220h70v70h-70zM110 110h70v70h-70zM110 0h70v70h-70zM220 220h70v70h-70zM220 110h70v70h-70zM220 0h70v70h-70z"/></g></svg>',
      heartIcon =
        '<svg class="favoriteClick" xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewbox="0 0 70 70" preserveAspectRatio="none"><path d="M66.43 20.39c-.93-10.37-8.21-17.9-17.32-17.9a17.224 17.224 0 0 0-14.76 8.57 16.588 16.588 0 0 0-14.4-8.57c-9.11 0-16.39 7.52-17.33 17.9a18.807 18.807 0 0 0 .55 6.8 29.14 29.14 0 0 0 8.86 14.91l22.31 20.41L57.02 42.1a29.227 29.227 0 0 0 8.87-14.91 18.412 18.412 0 0 0 .54-6.8z" data-name="fave ico" class="heart-fill"/></svg>',
      playIcon =
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"/><path fill="#fff" d="M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/></svg>';

    if (this.state.type == "movies") {
      if (configuration.title == "bidiotv") {
        if (!this.state.switchToFavourite) {
          return hollywoodMovies
            .sort((a, b) => a.id > b.id)
            .map((videos, key) => {
              let vid_category = videos.name;

              return (
                <div key={key} className="category-slider">
                  <Row>
                    <Col>
                      <div className="d-flex justify-content-between channel-head">
                        <h3 className="channel-title">{videos.name}</h3>
                        <a
                          className="channel-browse"
                          href={"/#/videos/movies/" + videos.id}
                        >
                          <span
                            className={
                              config.useMobiofitTheme
                                ? "grid-icon-mobiofit"
                                : "grid-icon"
                            }
                            dangerouslySetInnerHTML={{ __html: gridIcon }}
                          />
                          <FormattedMessage
                            id="viewAll"
                            defaultMessage="View All"
                          />
                        </a>
                      </div>
                      {videos.videos ? (
                        <Swiper
                          {...slides}
                          rebuildOnUpdate={false}
                          shouldSwiperUpdate={true}
                        >
                          {this.shuffle(videos.videos).map((m, k) => {
                            return (
                              <div
                                key={m.id}
                                className="portrait__slide hover__data movies-thumb"
                                onClick={this.goToPlayMovies.bind(
                                  this,
                                  {
                                    video: m,
                                    category: vid_category,
                                    categoryId: videos.id,
                                  },
                                  "movies",
                                )}
                                style={{ marginRight: "10px !important" }}
                              >
                                <img src={m.preview} alt={m.name} />
                                <div className="channels-thumb__fav">
                                  <input
                                    className="icon-toggle favoriteClick"
                                    id={m.id}
                                    type="checkbox"
                                    checked={this.isVideoFavorite(m.id)}
                                    onChange={() => {
                                      console_log("");
                                    }}
                                  />
                                  <label
                                    className="icon-toggle-label favoriteClick"
                                    htmlFor={m.id}
                                  >
                                    <span className="favoriteClick">
                                      <i
                                        className="fa fa-star favoriteClick"
                                        aria-hidden="true"
                                      ></i>
                                    </span>
                                  </label>
                                </div>
                                <div className="hover__details">
                                  <div className="hover__container">
                                    <div className="hover__title-wrap">
                                      <h3 className="hover__title">{m.name}</h3>
                                    </div>
                                    {/* <span className="hollow-arrow" dangerouslySetInnerHTML={{ __html: playIcon }} /> */}
                                    <div className="hover__title-wrap">
                                      <h3 className="hover__title">
                                        <FormattedMessage
                                          id="comingSoon"
                                          defaultMessage="Coming soon"
                                        />
                                      </h3>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </Swiper>
                      ) : (
                        ""
                      )}
                    </Col>
                  </Row>
                </div>
              );
            });
        } else if (
          this.state.switchToFavourite &&
          packagvideosbidioFavorite.length <= 0
        ) {
          return (
            <div className="no-favorite-category">
              <div className="no-favorites__pane">
                <h4 className="favorites__pane__title">
                  <FormattedMessage
                    id="noVids"
                    defaultMessage="No Videos Added To Favorites Yet"
                  />
                </h4>
                <p className="favorites__pane__text">
                  <FormattedMessage
                    id="addYour"
                    defaultMessage="Add your favorite videos to access and watch easily without any hassles."
                  />
                </p>
              </div>
              <div className="text-center">
                <a
                  className="common-btn common-btn--pink common-btn--fav"
                  onClick={() => this.gotovod()}
                >
                  <span className="common-btn__text">
                    <FormattedMessage
                      id="exploreVids"
                      defaultMessage="Explore Videos"
                    />
                  </span>
                </a>
              </div>
            </div>
          );
        } else {
          return hollywoodMovies
            .sort((a, b) => a.id > b.id)
            .map((videos, key) => {
              let packageVideosbidio = videos.videos.filter((video) => {
                if (~favoriteVideosIds.indexOf(video.id)) {
                  return video;
                }
              });
              if (packageVideosbidio.length > 0) {
                return (
                  <div key={key} className="category-slider">
                    <Row>
                      <Col>
                        <div className="d-flex justify-content-between channel-head">
                          <h3 className="channel-title">{videos.name}</h3>
                          <a
                            className="channel-browse"
                            href={"/#/videos/movies/" + videos.id}
                          >
                            <span
                              className={
                                config.useMobiofitTheme
                                  ? "grid-icon-mobiofit"
                                  : "grid-icon"
                              }
                              dangerouslySetInnerHTML={{ __html: gridIcon }}
                            />
                            <FormattedMessage
                              id="viewAll"
                              defaultMessage="View All"
                            />
                          </a>
                        </div>
                        {packageVideosbidio ? (
                          <Swiper
                            {...slides}
                            rebuildOnUpdate={false}
                            shouldSwiperUpdate={true}
                          >
                            {this.shuffle(packageVideosbidio).map((m, k) => {
                              return (
                                <div
                                  key={k}
                                  className="portrait__slide hover__data movies-thumb"
                                  onClick={this.goToPlayMovies.bind(
                                    this,
                                    { video: m, categoryId: videos.id },
                                    "movies",
                                  )}
                                  style={{ marginRight: "10px !important" }}
                                >
                                  <img src={m.preview} alt={m.name} />
                                  <div className="channels-thumb__fav">
                                    <input
                                      className="icon-toggle favoriteClick"
                                      id={m.id}
                                      type="checkbox"
                                      checked={this.isVideoFavorite(m.id)}
                                      onChange={() => {
                                        console_log("");
                                      }}
                                    />
                                    <label
                                      className="icon-toggle-label favoriteClick"
                                      htmlFor={m.id}
                                    >
                                      <span className="favoriteClick">
                                        <i
                                          className="fa fa-star favoriteClick"
                                          aria-hidden="true"
                                        ></i>
                                      </span>
                                    </label>
                                  </div>
                                  <div className="hover__details">
                                    <div className="hover__container">
                                      <div className="hover__title-wrap">
                                        <h3 className="hover__title">
                                          {m.name}
                                        </h3>
                                      </div>
                                      {/* <span className="hollow-arrow" dangerouslySetInnerHTML={{ __html: playIcon }} /> */}
                                      <div className="hover__title-wrap">
                                        <h3 className="hover__title">
                                          Coming soon
                                        </h3>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </Swiper>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>
                  </div>
                );
              }
            });
        }
      } else if (!this.state.switchToFavourite && this.props.category.videos) {
        return this.props.category.videos
          .sort((a, b) => a.id > b.id)
          .map((videos, key) => {
            return (
              <div key={key} className="category-slider">
                <Row>
                  <Col>
                    <div className="d-flex justify-content-between channel-head">
                      <h3 className="channel-title">{videos.name}</h3>
                      <a
                        className="channel-browse"
                        href={"/#/videos/" + videos.id}
                      >
                        <span
                          className={
                            config.useMobiofitTheme
                              ? "grid-icon-mobiofit"
                              : "grid-icon"
                          }
                          dangerouslySetInnerHTML={{ __html: gridIcon }}
                        />
                        <FormattedMessage
                          id="viewAll"
                          defaultMessage="View All"
                        />
                      </a>
                    </div>
                    {videos.videos ? (
                      <Swiper
                        {...slides}
                        rebuildOnUpdate={false}
                        shouldSwiperUpdate={true}
                      >
                        {this.shuffle(videos.videos).map((v, k) => {
                          return (
                            <div
                              key={v.id}
                              className="channels-thumb"
                              onClick={this.goToPlayMovies.bind(
                                this,
                                { video: v, categoryId: videos.id },
                                "movies",
                              )}
                            >
                              <div className="channels-image">
                                <img
                                  className="channels-thumb__image"
                                  src={v.preview}
                                  alt={v.name}
                                />
                                <div className="channels-thumb__details">
                                  <div className="channels-thumb__fav">
                                    <input
                                      className="icon-toggle favoriteClick"
                                      id={"vod-" + v.id}
                                      type="checkbox"
                                      checked={this.isVideoFavorite(v.id)}
                                      onChange={() => {
                                        console_log("favorite Changed");
                                      }}
                                    />
                                    <label
                                      className="icon-toggle-label favoriteClick"
                                      htmlFor={"vod-" + v.id}
                                    >
                                      <span className="favoriteClick">
                                        <i
                                          className="fa fa-star favoriteClick"
                                          aria-hidden="true"
                                        ></i>
                                      </span>
                                    </label>
                                  </div>
                                  <div className="channels-thumb__inner">
                                    <div className="channels-thumb__name">
                                      {v.name}
                                    </div>
                                    {/* <div className="channels-thumb__extra">
                                                                            <span className="channels-thumb__time">1h 40m</span>
                                                                        </div> */}
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </Swiper>
                    ) : (
                      ""
                    )}
                  </Col>
                </Row>
              </div>
            );
          });
      } else {
        if (orangeFavorite.length <= 0 && recentlyAddedFavorite.length <= 0) {
          return (
            <div className="no-favorite-category">
              <div className="no-favorites__pane">
                <h4 className="favorites__pane__title">
                  <FormattedMessage
                    id="noVids"
                    defaultMessage="No Videos Added To Favorites Yet"
                  />
                </h4>
                <p className="favorites__pane__text">
                  <FormattedMessage
                    id="addYour"
                    defaultMessage="Add your favorite videos to access and watch easily without any hassles."
                  />
                </p>
              </div>
              <div className="text-center">
                <a
                  className="common-btn common-btn--pink common-btn--fav"
                  onClick={() => this.gotovod()}
                >
                  <span className="common-btn__text">
                    <FormattedMessage
                      id="exploreVids"
                      defaultMessage="Explore Videos"
                    />
                  </span>
                </a>
              </div>
            </div>
          );
        } else {
          return this.props.category.videos
            .sort((a, b) => a.id > b.id)
            .map((videos, key) => {
              let packageVideos = videos.videos.filter((video) => {
                if (~favoriteVideosIds.indexOf(video.id)) {
                  return video;
                }
              });
              if (packageVideos.length > 0) {
                return (
                  <div key={key} className="category-slider">
                    <Row>
                      <Col>
                        <div className="d-flex justify-content-between channel-head">
                          <h3 className="channel-title">{videos.name}</h3>
                          <a
                            className="channel-browse"
                            href={"/#/videos/" + videos.id}
                          >
                            <span
                              className={
                                config.useMobiofitTheme
                                  ? "grid-icon-mobiofit"
                                  : "grid-icon"
                              }
                              dangerouslySetInnerHTML={{ __html: gridIcon }}
                            />
                            <FormattedMessage
                              id="viewAll"
                              defaultMessage="View All"
                            />
                          </a>
                        </div>
                        {packageVideos ? (
                          <Swiper
                            {...slides}
                            rebuildOnUpdate={false}
                            shouldSwiperUpdate={true}
                          >
                            {this.shuffle(packageVideos).map((v, k) => {
                              return (
                                <div
                                  key={v.id}
                                  className="channels-thumb"
                                  onClick={this.goToPlayMovies.bind(
                                    this,
                                    { video: v },
                                    "movies",
                                  )}
                                >
                                  <div className="channels-image">
                                    <img
                                      className="channels-thumb__image"
                                      src={v.preview}
                                      alt={v.name}
                                    />
                                    <div className="channels-thumb__details">
                                      <div className="channels-thumb__fav">
                                        <input
                                          className="icon-toggle favoriteClick"
                                          id={"vod-" + v.id}
                                          type="checkbox"
                                          checked={this.isVideoFavorite(v.id)}
                                          onChange={() => {
                                            console_log("favorite Changed");
                                          }}
                                        />
                                        <label
                                          className="icon-toggle-label favoriteClick"
                                          htmlFor={"vod-" + v.id}
                                        >
                                          <span className="favoriteClick">
                                            <i
                                              className="fa fa-star favoriteClick"
                                              aria-hidden="true"
                                            ></i>
                                          </span>
                                        </label>
                                      </div>
                                      <div className="channels-thumb__inner">
                                        <div className="channels-thumb__name">
                                          {v.name}
                                        </div>
                                        {/* <div className="channels-thumb__extra">
                                                                                    <span
                                                                                        className="channels-thumb__time">1h 40m</span>
                                                                                </div> */}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </Swiper>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>
                  </div>
                );
              }
            });
        }
      }
    }
  }

  shuffle(videoArray) {
    // do not shuffle
    if (config.subDomain === "premium") return videoArray;

    if (this.state.shuffleCount === 0) {
      let ctr = videoArray.length;
      let temp;
      let index;
      // While there are elements in the array
      while (ctr > 0) {
        // Pick a random index
        index = Math.floor(Math.random() * ctr);
        // Decrease ctr by 1
        ctr--;
        // And swap the last element with it
        temp = videoArray[ctr];
        videoArray[ctr] = videoArray[index];
        videoArray[index] = temp;
      }
      this.setState({
        shuffleCount: this.state.shuffleCount + 1,
      });
    }
    return videoArray;
  }
  onClickWhatsappIcon() {
    sendData("", "", "", "WA chat clicked", {
      url: window.location.href,
      page: "homepage",
    });
    window.open("https://wa.me/12028528006?text=Hello");
  }

  goToDownloadapks({ apkurl }) {
    const a = document.createElement("a");
    a.href = apkurl;
    a.download = ""; // Browser ko force karega download mode me
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  render() {
    let movies1 = [];
    let url = window.location.origin;

    if (config.subDomain == "safaricom") {
      movies1 = safarimovies;
    } else if (
      config.subDomain == "bidiotv" ||
      config.subDomain == "uk" ||
      config.subDomain == "be" ||
      config.subDomain == "id" ||
      config.subDomain == "it" ||
      config.subDomain == "sa" ||
      config.subDomain == "nl"
    ) {
      movies1 = [];
    } else if (config.subDomain == "es") {
      movies1 = esmobiotv;
    } else if (config.subDomain == "watch" || config.subDomain == "vn") {
      movies1 = movies;
    } else {
      movies1 = movies1;
    }

    const portraitSlides = {
        spaceBetween: 10,
        direction: "horizontal",
        slidesPerView: "auto",
        speed: 500,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
      slides = {
        spaceBetween: 30,
        direction: "horizontal",
        slidesPerView: "auto",
        speed: 500,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          575: {
            spaceBetween: 15,
          },
        },
      },
      heartIcon =
        '<svg class="favoriteClick" xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewbox="0 0 70 70" preserveAspectRatio="none"><path d="M66.43 20.39c-.93-10.37-8.21-17.9-17.32-17.9a17.224 17.224 0 0 0-14.76 8.57 16.588 16.588 0 0 0-14.4-8.57c-9.11 0-16.39 7.52-17.33 17.9a18.807 18.807 0 0 0 .55 6.8 29.14 29.14 0 0 0 8.86 14.91l22.31 20.41L57.02 42.1a29.227 29.227 0 0 0 8.87-14.91 18.412 18.412 0 0 0 .54-6.8z" data-name="fave ico" class="heart-fill"/></svg>',
      playIcon =
        '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M0 0h24v24H0z" fill="none"/><path fill="#fff" d="M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/></svg>',
      gridIcon =
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 290 290" width="12" height="12"><g fill="#d51a92"><path d="M0 220h70v70H0zM0 110h70v70H0zM0 0h70v70H0zM110 220h70v70h-70zM110 110h70v70h-70zM110 0h70v70h-70zM220 220h70v70h-70zM220 110h70v70h-70zM220 0h70v70h-70z"/></g></svg>';
    let favoriteChannelsIds = this.props.favorite.channels.map(
      (c) => c.channelId,
    );
    let favoriteVideosIds = this.props.favorite.videos.map((v) => v.videoId);
    let recentlyAdded = [].concat.apply(
      [],
      movies1.map((c) => c.videos),
    );
    let recentlyAddedFavorite = recentlyAdded.filter((m) => {
      if (~favoriteVideosIds.indexOf(m.id)) return m;
    });
    let mixContent = bidiotvMoviesListByLang.concat(this.props.category.videos);
    let mixcontentVideos = [].concat.apply(
      [],
      mixContent.map((c) => c.videos),
    );
    let mixcontentVideosFavorite = mixcontentVideos.filter((m) => {
      if (~favoriteVideosIds.indexOf(m.id)) return m;
    });
    const bannerSliderClass =
      config.subDomain == "iq"
        ? "category banner-slider ar"
        : "category banner-slider";
    return (
      <section
        // className={bannerSliderClass}
        className={"category banner-slider"}
      >
        {this.setBanner()}
        {config.subDomain == "no" ? (
          <button
            className="whatsapp-button"
            onClick={() => this.onClickWhatsappIcon()}
          >
            <img className="whatsapp-img" src="./img/whatsapp.png" />
          </button>
        ) : null}
        <div className="category-head">
          <h3>
            {!this.state.switchToFavourite ? (
              <FormattedMessage id="allCat" defaultMessage="All Categories" />
            ) : (
              <FormattedMessage id="allFavs" defaultMessage="All Favorites" />
            )}
          </h3>
          <div className="category-head__favorite">
            <h3>
              <FormattedMessage id="favorites" defaultMessage="Favorites" />
            </h3>
            <label
              className="switch"
              style={config.lang === "ar" ? { marginRight: "10px" } : {}}
            >
              <input
                type="checkbox"
                className="switch__checkbox"
                checked={this.state.switchToFavourite}
                onChange={this.showFavorite}
              />
              <span className="switch__slider round"></span>
            </label>
          </div>
        </div>

        {this.state.type == "tv"
          ? !this.state.switchToFavourite && this.props.category.categories
            ? this.props.category.categories.map((category) => {
                return (
                  <div key={category.categoryId} className="category-slider">
                    <Row>
                      <Col>
                        <div className="d-flex justify-content-between channel-head">
                          <h3 className="channel-title">{category.name}</h3>
                          <a
                            className="channel-browse"
                            href={"/#/channels/" + category.categoryId}
                          >
                            <span
                              className={
                                config.useMobiofitTheme
                                  ? "grid-icon-mobiofit"
                                  : "grid-icon"
                              }
                              dangerouslySetInnerHTML={{ __html: gridIcon }}
                            />
                            <FormattedMessage
                              id="viewAll"
                              defaultMessage="View All"
                            />
                          </a>
                        </div>

                        {this.props.category.channels ? (
                          <Swiper
                            {...slides}
                            rebuildOnUpdate={false}
                            shouldSwiperUpdate={true}
                          >
                            {this.props.category.channels.map((channel) => {
                              let categoryIds = channel.channelCategories.map(
                                (c) => c.categoryId,
                              );
                              if (~categoryIds.indexOf(category.categoryId)) {
                                return (
                                  <div
                                    key={channel.channelId}
                                    className="channels-thumb channels-thumb--genre"
                                    onClick={this.goToPlay.bind(this, {
                                      channel: channel,
                                    })}
                                  >
                                    <div className="channels-image channels-image--genre">
                                      <img
                                        className="channels-thumb__image channels-thumb__image--genre"
                                        src={
                                          channel.channelImage
                                            ? vars.BASE_URL +
                                              "uploads/" +
                                              channel.channelImage
                                            : "./img/thumbnail-2.jpg"
                                        }
                                        alt={channel.channelName}
                                      />
                                      <img
                                        className="channels-thumb__icon"
                                        src={channel.channelLogo}
                                        alt={channel.channelName}
                                      />
                                      <div className="channels-thumb__details">
                                        <div className="channels-thumb__fav">
                                          <input
                                            className="icon-toggle favoriteClick"
                                            id={
                                              "tv-" +
                                              category.categoryId +
                                              channel.channelId
                                            }
                                            type="checkbox"
                                            checked={this.isChannelFavorite(
                                              channel.channelId,
                                            )}
                                            onChange={() => {
                                              console_log("favorite Changed");
                                            }}
                                          />
                                          <label
                                            className="icon-toggle-label favoriteClick"
                                            htmlFor={
                                              "tv-" +
                                              category.categoryId +
                                              channel.channelId
                                            }
                                          >
                                            <span className="favoriteClick">
                                              <i
                                                className="fa fa-star favoriteClick"
                                                aria-hidden="true"
                                              ></i>
                                            </span>
                                          </label>
                                        </div>
                                        <div className="channels-thumb__inner">
                                          <div className="channels-thumb__name">
                                            {channel.channelName}
                                          </div>
                                          <div className="channels-thumb__extra">
                                            <span className="channels-thumb__status">
                                              <i
                                                className="fa fa-feed"
                                                aria-hidden="true"
                                              ></i>{" "}
                                              Live Now
                                            </span>
                                            {/*<span className="channels-thumb__views">{((Math.random() * 2) + 1).toFixed(1)}M Viewing</span>*/}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                );
                              }
                            })}
                          </Swiper>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>
                  </div>
                );
              })
            : this.props.category.categories.map((category) => {
                let categoryChannels = this.props.category.channels.filter(
                  (channel) => {
                    let categoryIds = channel.channelCategories.map(
                      (c) => c.categoryId,
                    );
                    if (
                      ~categoryIds.indexOf(category.categoryId) &&
                      ~favoriteChannelsIds.indexOf(channel.channelId)
                    ) {
                      return channel;
                    }
                  },
                );
                if (categoryChannels.length > 0) {
                  return (
                    <div key={category.categoryId} className="category-slider">
                      <Row>
                        <Col>
                          <div className="d-flex justify-content-between channel-head">
                            <h3 className="channel-title">{category.name}</h3>
                            <a
                              className="channel-browse"
                              href={"/#/channels/" + category.categoryId}
                            >
                              <span
                                className={
                                  config.useMobiofitTheme
                                    ? "grid-icon-mobiofit"
                                    : "grid-icon"
                                }
                                dangerouslySetInnerHTML={{
                                  __html: gridIcon,
                                }}
                              />
                              <FormattedMessage
                                id="viewAll"
                                defaultMessage="View All"
                              />
                            </a>
                          </div>

                          {categoryChannels ? (
                            <Swiper
                              {...slides}
                              rebuildOnUpdate={false}
                              shouldSwiperUpdate={true}
                            >
                              {categoryChannels.map((channel) => {
                                let categoryIds = channel.channelCategories.map(
                                  (c) => c.categoryId,
                                );
                                if (~categoryIds.indexOf(category.categoryId)) {
                                  return (
                                    <div
                                      key={channel.channelId}
                                      className="channels-thumb channels-thumb--genre"
                                      onClick={this.goToPlay.bind(this, {
                                        channel: channel,
                                      })}
                                    >
                                      <div className="channels-image channels-image--genre">
                                        <img
                                          className="channels-thumb__image channels-thumb__image--genre"
                                          src={
                                            channel.channelImage
                                              ? vars.BASE_URL +
                                                "uploads/" +
                                                channel.channelImage
                                              : "./img/thumbnail-2.jpg"
                                          }
                                          alt={channel.channelName}
                                        />
                                        <img
                                          className="channels-thumb__icon"
                                          src={channel.channelLogo}
                                          alt={channel.channelName}
                                        />
                                        <div className="channels-thumb__details">
                                          <div className="channels-thumb__fav">
                                            <input
                                              className="icon-toggle favoriteClick"
                                              id={
                                                "tv-" +
                                                category.categoryId +
                                                channel.channelId
                                              }
                                              type="checkbox"
                                              checked={this.isChannelFavorite(
                                                channel.channelId,
                                              )}
                                              onChange={() => {
                                                console_log("favorite Changed");
                                              }}
                                            />
                                            <label
                                              className="icon-toggle-label favoriteClick"
                                              htmlFor={
                                                "tv-" +
                                                category.categoryId +
                                                channel.channelId
                                              }
                                            >
                                              <span className="favoriteClick">
                                                <i
                                                  className="fa fa-star favoriteClick"
                                                  aria-hidden="true"
                                                ></i>
                                              </span>
                                            </label>
                                          </div>
                                          <div className="channels-thumb__inner">
                                            <div className="channels-thumb__name">
                                              {channel.channelName}
                                            </div>
                                            <div className="channels-thumb__extra">
                                              <span className="channels-thumb__status">
                                                <i
                                                  className="fa fa-feed"
                                                  aria-hidden="true"
                                                ></i>{" "}
                                                Live Now
                                              </span>
                                              {/*<span className="channels-thumb__views">{((Math.random() * 2) + 1).toFixed(1)}M Viewing</span>*/}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                }
                              })}
                            </Swiper>
                          ) : (
                            ""
                          )}
                        </Col>
                      </Row>
                    </div>
                  );
                }
              })
          : ""}
        {this.state.type === "vod"
          ? !this.state.switchToFavourite && movies1
            ? movies1.map((category) => {
                let category_name = category.name;
                return (
                  <div key={category.id} className="portrait-wrapper">
                    <div className="d-flex justify-content-between channel-head">
                      <h3 className="channel-title">{category.name}</h3>
                      <a
                        className="channel-browse"
                        href={"/#/movies/" + category.id}
                      >
                        <span
                          className={
                            config.useMobiofitTheme
                              ? "grid-icon-mobiofit"
                              : "grid-icon"
                          }
                          dangerouslySetInnerHTML={{ __html: gridIcon }}
                        />
                        <FormattedMessage
                          id="viewAll"
                          defaultMessage="View All"
                        />
                      </a>
                    </div>
                    {category.videos.length > 0 ? (
                      <Swiper
                        {...portraitSlides}
                        rebuildOnUpdate={false}
                        shouldSwiperUpdate={true}
                      >
                        {this.shuffle(category.videos).map((m) => {
                          return (
                            <div
                              key={m.id}
                              className="portrait__slide hover__data"
                              onClick={this.goToPlayOthers.bind(this, {
                                show: m,
                                category: category_name,
                                categoryId: category.id,
                              })}
                            >
                              <img src={m.preview} alt={m.name} />
                              <div className="channels-thumb__fav">
                                <input
                                  className="icon-toggle favoriteClick"
                                  id={m.id}
                                  type="checkbox"
                                  checked={this.isVideoFavorite(m.id)}
                                  onChange={() => {
                                    console_log("");
                                  }}
                                />
                                <label
                                  className="icon-toggle-label favoriteClick"
                                  htmlFor={m.id}
                                >
                                  <span className="favoriteClick">
                                    <i
                                      className="fa fa-star favoriteClick"
                                      aria-hidden="true"
                                    ></i>
                                  </span>
                                </label>
                              </div>
                              <div className="hover__details">
                                <div className="hover__container">
                                  <div className="hover__title-wrap">
                                    <h3 className="hover__title">{m.name}</h3>
                                  </div>
                                  <span
                                    className="hollow-arrow"
                                    dangerouslySetInnerHTML={{
                                      __html: playIcon,
                                    }}
                                  />
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </Swiper>
                    ) : (
                      ""
                    )}
                  </div>
                );
              })
            : movies1.map((category) => {
                let newVideos = category.videos.filter((video) => {
                  if (~favoriteVideosIds.indexOf(video.id)) {
                    return video;
                  }
                });
                if (newVideos.length > 0) {
                  return (
                    <div key={category.id} className="portrait-wrapper">
                      <div className="d-flex justify-content-between channel-head">
                        <h3 className="channel-title">{category.name}</h3>
                        <a
                          className="channel-browse"
                          href={"/#/movies/" + category.id}
                        >
                          <span
                            className={
                              config.useMobiofitTheme
                                ? "grid-icon-mobiofit"
                                : "grid-icon"
                            }
                            dangerouslySetInnerHTML={{ __html: gridIcon }}
                          />
                          <FormattedMessage
                            id="viewAll"
                            defaultMessage="View All"
                          />
                        </a>
                      </div>
                      {newVideos.length > 0 ? (
                        <Swiper
                          {...portraitSlides}
                          rebuildOnUpdate={false}
                          shouldSwiperUpdate={true}
                        >
                          {this.shuffle(newVideos.reverse()).map((m) => {
                            return (
                              <div
                                key={m.id}
                                className="portrait__slide hover__data"
                                onClick={this.goToPlayOthers.bind(this, {
                                  show: m,
                                  categoryId: category.id,
                                })}
                              >
                                <img src={m.preview} alt={m.name} />
                                <div className="channels-thumb__fav">
                                  <input
                                    className="icon-toggle favoriteClick"
                                    id={m.id}
                                    type="checkbox"
                                    checked={this.isVideoFavorite(m.id)}
                                    onChange={() => {
                                      console_log("");
                                    }}
                                  />
                                  <label
                                    className="icon-toggle-label favoriteClick"
                                    htmlFor={m.id}
                                  >
                                    <span className="favoriteClick">
                                      <i
                                        className="fa fa-star favoriteClick"
                                        aria-hidden="true"
                                      ></i>
                                    </span>
                                  </label>
                                </div>
                                <div className="hover__details">
                                  <div className="hover__container">
                                    <div className="hover__title-wrap">
                                      <h3 className="hover__title">{m.name}</h3>
                                    </div>
                                    <span
                                      className="hollow-arrow"
                                      dangerouslySetInnerHTML={{
                                        __html: playIcon,
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </Swiper>
                      ) : (
                        ""
                      )}
                    </div>
                  );
                }
              })
          : ""}

        {this.state.type == "vod" &&
        this.state.switchToFavourite &&
        config.title == "es" &&
        recentlyAddedFavorite.length <= 0 ? (
          <div className="no-favorite-category">
            <div className="no-favorites__pane">
              <h4 className="favorites__pane__title">
                <FormattedMessage
                  id="noVids"
                  defaultMessage="No Videos Added To Favorites Yet"
                />
              </h4>
              <p className="favorites__pane__text">
                <FormattedMessage
                  id="addYour"
                  defaultMessage="Add your favorite videos to access and watch easily without any hassles."
                />
              </p>
            </div>
            <div className="text-center">
              <a
                className="common-btn common-btn--pink common-btn--fav"
                onClick={() => this.gotovod()}
              >
                <span className="common-btn__text">
                  <FormattedMessage
                    id="exploreVids"
                    defaultMessage="Explore Videos"
                  />
                </span>
              </a>
            </div>
          </div>
        ) : (
          ""
        )}
        {this.setVideos()}
        {this.state.type === "movies" && this.setMovies()}
        {window.location.hostname === "fr.mobiotv.com" ? (
          <div class="category-slider" style={{ marginRight: "30px" }}>
            <div class="row">
              <div class="col">
                <div class="d-flex justify-content-between channel-head">
                  <h3 class="channel-title">Utilities</h3>
                </div>
                <div class="swiper-container swiper-container-horizontal">
                  <div
                    class="swiper-wrapper"
                    style={{ transform: "translate3d(0px, 0px, 0px)" }}
                  >
                    <div
                      class="swiper-slide channels-thumb swiper-slide-active"
                      style={{ marginRight: "30px" }}
                      onClick={this.goToDownloadapks.bind(this, {
                        apkurl:
                          "https://cdn.mobiotv.com/bidiotv/Utilities/mergemultiplepdf.apk",
                      })}
                    >
                      <div class="channels-image">
                        <img
                          class="channels-thumb__image"
                          src="https://cdn.mobiotv.com/bidiotv/Utilities/mergemultiplepdf.png"
                          alt="PDF Merger"
                        />
                        <div class="channels-thumb__details">
                          <div class="channels-thumb__fav">
                            <input
                              class="icon-toggle favoriteClick"
                              id="vod-811"
                              type="checkbox"
                            />
                            <label
                              class="icon-toggle-label favoriteClick"
                              for="vod-811"
                            >
                              <span class="favoriteClick">
                                <i
                                  class="fa fa-star favoriteClick"
                                  aria-hidden="true"
                                ></i>
                              </span>
                            </label>
                          </div>
                          <div class="channels-thumb__inner">
                            <div class="channels-thumb__name">PDF Merger</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="swiper-slide channels-thumb swiper-slide-next"
                      style={{ marginRight: "30px" }}
                      onClick={this.goToDownloadapks.bind(this, {
                        apkurl:
                          "https://cdn.mobiotv.com/bidiotv/Utilities/qrscanner.apk",
                      })}
                    >
                      <div class="channels-image">
                        <img
                          class="channels-thumb__image"
                          src="https://cdn.mobiotv.com/bidiotv/Utilities/qrscanner.png"
                          alt="QR Scanner"
                        />
                        <div class="channels-thumb__details">
                          <div class="channels-thumb__fav">
                            <input
                              class="icon-toggle favoriteClick"
                              id="vod-800"
                              type="checkbox"
                            />
                            <label
                              class="icon-toggle-label favoriteClick"
                              for="vod-800"
                            >
                              <span class="favoriteClick">
                                <i
                                  class="fa fa-star favoriteClick"
                                  aria-hidden="true"
                                ></i>
                              </span>
                            </label>
                          </div>
                          <div class="channels-thumb__inner">
                            <div class="channels-thumb__name">QR Scanner</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="swiper-button-next swiper-button-disabled"
                    tabindex="0"
                    role="button"
                    aria-label="Next slide"
                    aria-disabled="true"
                  ></div>
                  <div
                    class="swiper-button-prev swiper-button-disabled"
                    tabindex="0"
                    role="button"
                    aria-label="Previous slide"
                    aria-disabled="true"
                  ></div>
                  <span
                    class="swiper-notification"
                    aria-live="assertive"
                    aria-atomic="true"
                  ></span>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </section>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    access: state.WelcomeReducer,
    account: state.AccountReducer,
    category: state.CategoryReducer,
    country: state.CountryReducer,
    domain: state.DomainReducer,
    favorite: state.FavoriteReducer,
    flashmessage: state.FlashMessageReducer,
    historyVideos: state.HistoryReducer,
    loader: state.ActivityIndicatorReducer,
    play: state.PlayReducer,
    smartTV: state.SmartTVReducer,
    splash: state.SplashScreenReducer,
    user: state.AuthenticationReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      show,
      hide,
      getVideoOrChannelRelatedData,
      showMessage,
      getDetails,
      getInterests,
      getVideosPackages,
      getVideos,
      getTVCategories,
      getChannels,
      addFavoriteChannel,
      addFavoriteVideo,
      setHeaderTitle,
      resetBack,
      addChannelHistory,
      addVideoHistory,
      addShowHistory,
      addLikesChannels,
      addLikesVideos,
    },
    dispatch,
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Category);



// WEBPACK FOOTER //
// ./src/components/Category/Category.js